import React from "react"; // eslint-disable-line no-unused-vars
import styled from "styled-components";
import { DropTarget } from "react-dnd";
import moment from "moment-timezone";

const CustomFreeContainer = styled.div`
border-top: 1px solid #2fdc16;
border-right: 1px solid #2fdc16;
background-color: #62e79b;
  color: #444;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;

    &:hover {
      background-color: #2fdc16;
      &::before {
        content: "${props => props.time}";
      }
    }
`;

const CustomFreeContainerOver = CustomFreeContainer.extend`
  height: 100%;
  /*background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAI0lEQVQYV2NkQAbHA/4zwvnHA/4zWG5ghAhAOSAmIzIHJAAAV1sLG03vu+QAAAAASUVORK5CYII=)
    repeat;*/
  background-color: #2fdc16;
  &::before {
    content: "${props => props.time}";
  }
`;
const Box = styled.div`
  background-color: #fff;
  color: #444;
  padding: 5px;
  display: flex;
  //  border-top: 1px solid #eee;
  border-right: 1px solid #fff;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: ${props => (props.time ? "0.9em" : "inherit")};
  border-top: ${props => (props.time ? "1px solid #eee" : "inherit")};
  &:nth-child(2) {
    border-top: ${props => (props.time ? "none" : "inherit")};
  }
`;
const Past = Box.extend`
  border-top: none;
  border-right: none;
  /*  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAM0lEQVQoU2NkwAP+////nxGXPFgSBLApgEmC5DAUIEtiKECXRFGATRKuAJckWAE+SZACAIKGIAUwJOAdAAAAAElFTkSuQmCC)
    repeat;*/
  /*url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQYV2NkQAI9PT3/GWF8EKekpIQRLADjgNiMyByQAADHBQ6o45FCxgAAAABJRU5ErkJggg==)
    repeat;*/
  //  background-color: #ccc;
  background-color: transparent;
`;

const CustomFreeTarget = {
  drop(props, monitor, component) {
    props.moveEvent(monitor.getItem().id, props.date);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

class CustomFree extends React.Component {
  state = { isPast: false };
  componentDidMount() {
    let interval = (this.props.date.diff(moment(), "minutes") + 1) * 60000;
    if (interval >= 2147483647) {
      interval = 2147483647;
    }
    this.interval = setTimeout(() => this.setState({ isPast: true }), interval);
  }
  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  render() {
    const { connectDropTarget, isOver } = this.props;
    if (this.state.isPast) {
      return (
        <div>
          <Past />
        </div>
      );
    }

    if (isOver) {
      return connectDropTarget(
        <div>
          <CustomFreeContainerOver time={this.props.time} />
        </div>
      );
    }

    return connectDropTarget(
      <div>
        <CustomFreeContainer
          time={this.props.time}
          onClick={this.props.availableSlotClick}
        />
      </div>
    );
  }
}

export default DropTarget("event", CustomFreeTarget, collect)(CustomFree);



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/CustomFree.js